module.exports = __webpack_public_path__ + "img/Incoming_data_grey.ef6d525c.svg";